import * as Types from './notificationActionTypes.js'

const initialState = {
    counter: 0
};

export default function notification(state = initialState, action) {
    switch (action.type) {
        case Types.SET_COUNTER:
            if (state.counter !== action.counter) {
                return Object.assign({}, state, { counter: action.counter });
            }
            return state;
        case Types.INCREMENT_COUNTER:        
                return Object.assign({}, state, { counter: state.counter + 1 });            
        default:
            return state;
    }
}